<div class="fixed bottom-0 right-0 mt-1 mr-1 z-50" >
  @for (alert of alertService.alerts$ | async; track alert) {
    <div
      (click)="removeAlert(alert)"
      class="alert {{ cssClass(alert) }}" @fade>
      <app-icon [class]="cssClass(alert)" class="icon" [icon]="alert.icon"></app-icon>
      <div class="flex flex-col px-3">
        <span class="alert-txt" [innerHTML]="alert.title"></span>
        @if (alert.desc) {
          <span class="alert-desc" [innerHTML]="alert.desc"></span>
        }
      </div>
    </div>
  }
</div>
